(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('scarpe-size-guide')) {
  customElements.define('scarpe-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('.scarpe-size-selector')) return;
      const table = this.querySelector('table');
      if (!table) return;
      const rows = [...table.querySelectorAll('tbody tr')];
      if (!rows.length) return;
      const heading = table.querySelector('thead th');
      if (!heading) return;
      const label = document.createElement('label');
      label.className = 'scarpe-size-selector';
      const text = document.createElement('span');
      text.textContent = heading.textContent.trim();
      const select = document.createElement('select');
      rows.forEach((row, index) => {
        const cell = row.querySelector('th, td');
        if (!cell) return;
        const option = document.createElement('option');
        option.value = String(index);
        option.textContent = cell.textContent.trim();
        select.append(option);
      });
      label.append(text, select);
      table.before(label);
      const highlight = () => {
        rows.forEach((row, index) => {
          row.classList.toggle('scarpe-size-active', index === Number(select.value));
        });
      };
      select.addEventListener('change', highlight);
      highlight();
    }
  });
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scarpe-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scarpe-collection-tabs')) {
    customElements.define('scarpe-collection-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enhanced) return;
        const tabs = Array.from(this.querySelectorAll('[data-scarpe-tab]'));
        const panels = tabs.map(tab => this.querySelector(tab.getAttribute('href')));
        if (!tabs.length || panels.some(panel => !panel)) return;
        const nav = this.querySelector('.scarpe-home-tabs__nav');
        nav.setAttribute('role', 'tablist');
        const activate = (index, focus = false) => {
          tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            panels[i].hidden = i !== index;
          });
          if (focus) tabs[index].focus();
        };
        tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panels[index].id);
          panels[index].setAttribute('role', 'tabpanel');
          panels[index].tabIndex = 0;
          tab.addEventListener('click', event => {
            event.preventDefault();
            activate(index);
          });
          tab.addEventListener('keydown', event => {
            let target;
            const rtl = getComputedStyle(this).direction === 'rtl';
            if (event.key === 'ArrowRight') target = index + (rtl ? -1 : 1);
            if (event.key === 'ArrowLeft') target = index + (rtl ? 1 : -1);
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = tabs.length - 1;
            if (event.key === ' ') target = index;
            if (target === undefined) return;
            event.preventDefault();
            activate((target + tabs.length) % tabs.length, true);
          });
          panels[index].addEventListener('shopify:block:select', () => activate(index));
        });
        activate(0);
        this.dataset.enhanced = 'true';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
